import React from "react";
import PropTypes from "prop-types";
import { Pagination } from "@mui/material";

const DataTablePagination = ({ totalPages, page, handlePageChange }) => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "12px 0", backgroundColor: "#1D1D1D" }}>
    <Pagination
      count={totalPages}
      page={page}
      onChange={(_, value) => handlePageChange(value)}
      color="primary"
      shape="rounded"
      showFirstButton
      showLastButton
      siblingCount={2}
      boundaryCount={1}
      sx={{
        '& .MuiPagination-ul': {
          gap: '2px',
        },
        '& .MuiButtonBase-root': {
          borderRadius: '4px', // square corners
          backgroundColor: 'transparent',
          color: '#efefef',
          border: '1px solid #444',
          transition: 'border-color 0.2s, color 0.2s, background 0.2s',
          boxShadow: 'none',
        },
        '& .MuiButtonBase-root.Mui-selected': {
          backgroundColor: '#1976d2',
          color: '#fff',
          border: '2px solid #1976d2',
        },
        '& .MuiButtonBase-root:hover': {
          backgroundColor: 'transparent',
          color: '#1976d2',
          border: '2px solid #1976d2',
        },
        '& .MuiPaginationItem-ellipsis': {
          color: '#fff',
        },
        '& .MuiPaginationItem-icon': {
          color: '#fff',
        },
        '& .Mui-disabled': {
          opacity: 0.4,
        },
      }}
    />
  </div>
);

DataTablePagination.propTypes = {
  totalPages: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  handlePageChange: PropTypes.func.isRequired
};

export default DataTablePagination;
